"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NowportsBrasilLTDA = void 0;
exports.NowportsBrasilLTDA = {
    id: 'nowportsBrasilLTDA',
    companyName: 'Nowports Brasil LTDA',
    transportModes: ['sea', 'air'],
    freightGate: {
        isOnboarded: true,
        realm: 'nowportsBrasilLTDA',
    },
    isInternal: false,
    isActive: true,
    countries: ['BR'],
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTm93cG9ydHNCcmFzaWxMVERBLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2FnZW50cy9kYXRhL05vd3BvcnRzQnJhc2lsTFREQS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFYSxRQUFBLGtCQUFrQixHQUFVO0lBQ3JDLEVBQUUsRUFBRSxvQkFBb0I7SUFDeEIsV0FBVyxFQUFFLHNCQUFzQjtJQUNuQyxjQUFjLEVBQUUsQ0FBQyxLQUFLLEVBQUUsS0FBSyxDQUFDO0lBQzlCLFdBQVcsRUFBRTtRQUNULFdBQVcsRUFBRSxJQUFJO1FBQ2pCLEtBQUssRUFBRSxvQkFBb0I7S0FDOUI7SUFDRCxVQUFVLEVBQUUsS0FBSztJQUNqQixRQUFRLEVBQUUsSUFBSTtJQUNkLFNBQVMsRUFBRSxDQUFDLElBQUksQ0FBQztDQUNwQixDQUFBIn0=